<suppliers-basket-overview
    [supplierBaskets]="supplierBaskets$ | async"
    [companySetting]="companySetting$ | async"
    [currencyTotals]="currencyTotals$ | async"
    [showStepperButtons]="showStepperButtons"
    [isEditableStep]="isEditableStep"
    [basketToggleStatus]="basketToggleStatus"
    [budgetOverruns]="budgetOverruns"
    [purchasingGroupAssignmentIssues]="purchasingGroupAssignmentIssues"
    [resolvedPurchasingGroups]="resolvedPurchasingGroups"
    [purchasingGroupVisible]="purchasingGroupVisible"
    [purchasingGroupValidationLoading]="purchasingGroupValidationLoading"
    [companyCodeId]="companyCodeId"
    (nextClicked)="openAddressSelection()"
    (validityChanged)="onValidityChange($event)"
></suppliers-basket-overview>
